module.exports = __webpack_public_path__ + "img/static-purchase-download-app-mobile.c7a8b42e.png";